import React, { useEffect, useRef, useState } from "react";

import CustomerViewModel from "./CustomerViewModel";

import { Button } from "primereact/button";
import { Column, ColumnEditorOptions, ColumnEvent } from "primereact/column";
import { DataTable, DataTableFilterMeta, DataTableFilterMetaData } from "primereact/datatable";
import { InputText } from "primereact/inputtext";

import { FilterMatchMode } from "primereact/api";

import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import './Customer.css';

import { useToast } from "../../../../Shared/hook/useToast";

interface ColumnMeta {
  field: string;
  header: string;
  editable: boolean;
}

export const CustomerView = ()=> {
  const [filters, setFilters] = useState<DataTableFilterMeta>({ global: { value: null, matchMode: FilterMatchMode.CONTAINS }});
  // const toast = useRef<Toast>(null);
  const { showSuccess, showError, showWarn, showInfo } = useToast();
//   const defaultValues = {
//     name: '',
// };
  const [visible, setVisible] = useState<boolean>(false);
  const {
    getCustomers,
    customers,
  } = CustomerViewModel();

  type LazyParamsType = {
          first: number;
          rows: number;
        };
  
  
          const [totalRecords, setTotalRecords] = useState(0);
          const [loading, setLoading] = useState(false);
          const [lazyParams, setLazyParams] = useState<LazyParamsType>({
              first: 1,
              rows: 10,
          });

  const columns: ColumnMeta[] = [
      {field: 'firstName', header: 'Nombre', editable: false},
      {field: 'lastName', header: 'Apellidos', editable: false},
      {field: 'dni', header: 'DNI', editable: false},
      {field: 'email', header: 'Correo', editable: false},
      {field: 'phoneNumber', header: 'Teléfono', editable: false},
      { field: 'status', header: 'Estado', editable: false },
  ];
  
      useEffect(() => {
        //getCustomers();

          const search = (filters['global'] as DataTableFilterMetaData)?.value || '';
          loadCustomers(lazyParams.first ?? 1, lazyParams.rows ?? 10, search);
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [lazyParams, filters]);


      const loadCustomers = async (first: number, rows: number, search: string = '') => {
        setLoading(true);
        const page = Math.floor(first / rows);
        //const search = filters?.global?.value || '';

        console.log(page);

        try {
            const result = await getCustomers(page+1, rows, search); // ya devuelve { items, totalItems }
            
            setTotalRecords(result.totalCount);
          } catch (error) {
            console.error("Error al cargar clientes", error);
          } finally {
            setLoading(false);
          }
      };


      // const show = (data: any) => {
      //       // @ts-ignore
      //     toast.current?.show({ severity: 'success', summary: 'Se registro', detail: `${data.name}`});
      // };

    //   const accept = async (id: string) => {
        
    //     let deleted = await removeColor(id);
    //     console.log(deleted);
    //     if(deleted){
    //       toast.current?.show({ severity: 'info', summary: 'Confirmada', detail: 'has aceptado', life: 3000 });
    //       await getColors();
    //     }
    // }

    // const reject = () => {
    //     toast.current?.show({ severity: 'warn', summary: 'Rechazada', detail: 'has rechazado', life: 3000 });
    // }


      // const onSubmit = (
      //   data: {
      //       name: string,
      //   }
      //   ) => {
      //     data.name && show(data);
      //     let datos =  data;
      //     if(datos){
      //       const colorData: Customer = {
      //         name: data.name,
      //         id: ""
      //       };
      //       createColor(colorData);
      //     }
      //     getColors();
      //     console.log(datos);
      //     reset();
      // };

    // const {
    //     control,
    //     formState: { errors },
    //     handleSubmit,
    //     reset
    // } = useForm({ defaultValues });

    // const getFormErrorMessage = (name: string) => {
    //     // @ts-ignore
    //     return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
    // };


      const onCellEditComplete = (e: ColumnEvent) => {
          let { rowData, newValue, field, originalEvent: event } = e;

          switch (field) {
              case 'id':
              default:
                  if (newValue.trim().length > 0) {
                    rowData[field] = newValue;
                    // updateColor(rowData);
                  }
                  else event.preventDefault();
                  break;
          }
      };

      const cellEditor = (options: ColumnEditorOptions) => {
        // if (options.field === 'state') return noTextEditor();
        // else return textEditor(options);
        return textEditor(options);
    };

    const textEditor = (options: ColumnEditorOptions) => {
        return (
            <InputText 
                type="text" 
                value={options.value || ''} // Asegúrate de que options.value no sea nulo o indefinido
                onChange={(e) => options.editorCallback!(e.target.value)} 
            />
        );
    };

      const onGlobalFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
          const value = event.target.value;
          let _filters = { ...filters };
          // @ts-ignore
          _filters['global'].value = value.toString() || '';

          setFilters(_filters);
          // setGlobalFilterValue(value);
      };

      const header = ()=>{
        // @ts-ignore
       const value = filters['global'] ? filters['global'].value : '';

       return (
           <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
               <h4 className="m-0">
                   {/* <button type="button" className="btn btn-dark" onClick={() => setVisible(true)}>
                    <FontAwesomeIcon icon={icon({name: 'plus'})} /> 
                   Nuevo color</button> */}

               </h4>
               <span className="p-input-icon-left">
                   <i className="pi pi-search" />
                   <InputText type="search" value={value || ''} onChange={(e) => 
                       onGlobalFilterChange(e)} placeholder="Buscar..." />
               </span>
           </div>
      )};

      const viewStatus = (status: number) => {

        return(
            <>
                <div className="d-flex">
                  <div className={`p-2 text-white rounded-2 ${status === 0 ? 'bg-danger' : 'bg-success' }`}>{status === 0 ? <FontAwesomeIcon className="fs-2" icon={icon({name: 'user-large-slash'})} /> : <FontAwesomeIcon className="fs-2" icon={icon({name: 'user-large'})} />}</div>
                </div>
            </>
        );
    }
    
    return (
        <>
          <div className="container-fluid">
            <div className="block-header">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 text-start">
                        <h2>Lista Clientes</h2>
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a href="/home" className="text-danger"><FontAwesomeIcon icon={icon({name: 'home'})} /></a>
                            </li>                            
                            <li className="breadcrumb-item">Lista Clientes</li>
                        </ul>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="d-flex flex-row-reverse">
                            <div className="page_action">
                                {/* <button type="button" className="btn btn-dark"><FontAwesomeIcon icon={icon({name: 'plus'})} /> Nuevo producto</button> */}
                            </div>
                            <div className="p-2 d-flex">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className='title-report'>
                    Aquí puedes ver los últimos clientes añadidos
                </div>
                {/* <InputSwitch  key={'index01254'} checked={checkedw} onChange={(e: InputSwitchChangeEvent) =>  setCheckedw(!checkedw)} /> */}
                
            </div>
            <div className='row'>
              <div className='col-lg-12'>
                <DataTable 
                    value={customers!} lazy paginator 
                    rows={lazyParams.rows} 
                    first={lazyParams.first} 
                    totalRecords={totalRecords} 
                    loading={loading} 
                    editMode="cell" 
                    rowsPerPageOptions={[5, 10, 15, 20]} 
                    tableStyle={{    minWidth: '50rem' }}
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}" 
                    globalFilterFields={['firstName', 'lastName', 'dni', 'email', 'phoneNumber']} 
                    emptyMessage="No customers found." 
                    stateStorage="session"
                    header={header} 
                    filters={filters} 
                    onFilter={(e) => setFilters(e.filters)}
                >
                    {columns.map(({ field, header, editable  }) => {
                            return <Column key={field} field={field} header={header}
                            body={ 
                              field === 'status' ? (e)=> viewStatus(e.status) : null
                            }
                            editor={editable ? (options) => cellEditor(options) : undefined} onCellEditComplete={onCellEditComplete} />
                    })}
                </DataTable>
               </div>
            </div>
          </div>
        </>
    );
}
